import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import useCategories from "../hooks/useCategories";
import { FaFile, FaImage, FaPlus } from "react-icons/fa";
import Toggle from "react-toggle";
import ImgUploadInput from "./ImgUploadInput";
import clsx from "clsx";

const initialState = {
    name: '',
    price: 0,
    providerName: '', // Asegúrate de que los nombres coincidan con tu estado
    description: '',
    image: null,
    file: null,
    category_id: '',
    chargePerForm: false,
    authorizedBy: '',
    account: '',
    seven: ''
};

const ManualItemForm = ({ setData, data }) => {

    const [newItemData, setNewItemData] = useState(initialState);
    const [showModal, setShowModal] = useState(false);

    const [uploadType, setUploadType] = useState('image');

    const [categoriesFilters, setCategoriesFilters] = useState({
        page: 1,
        perPage: 10,
        path: '',
        orderBy: 'path,ASC'
    });

    const [currentCategories, setCurrentCategories] = useState([]);

    const [{ categories, numberOfPages, loading: loadingCategories }] = useCategories({ params: categoriesFilters }, { useCache: false });

    useEffect(() => {
        setCurrentCategories(old => [...old, ...categories]);
    }, [categories])

    const handleNewItemChange = (e) => {
        setNewItemData((oldData) => {
            return {
                ...oldData,
                [e.target.name]: e.target.type === 'file' ? e?.target?.files?.[0] : e.target.value
            }
        });
    }

    const handleAddNewItem = (e) => {
        e.preventDefault();
        if (
            !newItemData?.name ||
            !newItemData?.price ||
            !newItemData?.providerName ||
            !newItemData?.description ||
            !newItemData?.category_id
        ) {
            alert('Todos lo campos son obligatorios');
            return;
        }

        if (!newItemData?.image && !newItemData?.file) {
            alert('Tienes que llenar el campo imagen o el campo archivo.');
            return;
        }

        setData((oldData) => {
            return {
                ...oldData,
                orderItems: [
                    ...oldData?.orderItems,
                    {
                        name: newItemData?.name,
                        image: newItemData?.image || null,
                        file: newItemData?.file || null,
                        providerName: newItemData?.providerName,
                        description: newItemData?.description,
                        quantity: 1,
                        price: newItemData?.price,
                        category_id: newItemData?.category_id,
                        code: '--',
                        chargePerForm: !!newItemData?.chargePerForm,
                        authorizedBy: newItemData?.chargePerForm ? newItemData?.authorizedBy : null,
                        account: newItemData?.chargePerForm ? newItemData?.account : null,
                        seven: newItemData?.chargePerForm ? newItemData?.seven : null,
                    }
                ]
            }
        });

        setNewItemData(initialState);
        setShowModal(false);

    };

    return (
        <>
            <button
                onClick={() => setShowModal(true)}
                className="align-items-center btn btn-primary"
                style={{ display: data?.service ? 'flex' : 'none', position: 'fixed', right: '16%', bottom: 20, width: 'fit-content' }}
            >
                <div>
                    Ingresar item
                </div>
                <div className="position-relative">
                    <FaPlus style={{ marginLeft: 10, fontSize: 34 }} />
                </div>
            </button>
            <Modal className="fade" size="lg" show={showModal}>
                <Modal.Header>
                    <Modal.Title>
                        Cargar información del nuevo item
                    </Modal.Title>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setShowModal?.(false)}
                    >
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleAddNewItem}>
                        <div className="row">
                            <div className="col-md-12 align-items-center justify-content-between d-flex">
                                <label className="d-block">
                                    <h4>Cobro por formular:</h4>
                                </label>
                                <Toggle onChange={() => setNewItemData((oldData) => {
                                    return {
                                        ...oldData,
                                        chargePerForm: !oldData?.chargePerForm
                                    }
                                })} checked={newItemData?.chargePerForm} />
                            </div>
                        </div>
                        {
                            newItemData?.chargePerForm &&
                            <div className="row animate__animated animate__fadeInRight mb-4">
                                <div className="col-md-4 form-group">
                                    <label>Autorizado por</label>
                                    <input
                                        type="text"
                                        value={newItemData?.authorizedBy}
                                        name="authorizedBy"
                                        className="form-control"
                                        onChange={handleNewItemChange}
                                    />
                                </div>
                                <div className="col-md-4 form-group">
                                    <label>Cuenta</label>
                                    <input
                                        type="text"
                                        value={newItemData?.account}
                                        name="account"
                                        className="form-control"
                                        onChange={handleNewItemChange}
                                    />
                                </div>
                                <div className="col-md-4 form-group">
                                    <label>Cebe</label>
                                    <input
                                        type="text"
                                        value={newItemData?.seven}
                                        name="seven"
                                        className="form-control"
                                        onChange={handleNewItemChange}
                                    />
                                </div>
                            </div>
                        }
                        <div className="border-bottom"></div>
                        <br />
                        <div className="row align-items-center">
                            <div className="col-md-4 form-group mb-4 text-center">
                                <button
                                    type="button"
                                    onClick={() => {
                                        setUploadType('image');
                                        setNewItemData(old => ({ ...old, file: null }))
                                    }}
                                    className={clsx(["btn w-100 mb-2 d-block btn-outline-primary", {
                                        'btn-primary': uploadType === 'image'
                                    }])}
                                >
                                    Imagen
                                    <FaImage />
                                </button>
                                <button
                                    type="button"
                                    onClick={() => {
                                        setUploadType('document');
                                        setNewItemData(old => ({ ...old, image: null }))
                                    }}
                                    className={clsx(["btn w-100 d-block btn-outline-primary", {
                                        'btn-primary': uploadType === 'document'
                                    }])}
                                >
                                    Documento
                                    <FaFile />
                                </button>

                            </div>
                            <div className="col-md-8 mb-4">
                                {
                                    uploadType === 'image' &&
                                    <ImgUploadInput
                                        name="image"
                                        style={{
                                            width: '100px',
                                            height: '100px'
                                        }}
                                        value={newItemData?.image}
                                        description="imagen"
                                        deleteButton={newItemData?.image}
                                        change={handleNewItemChange}
                                    />
                                }
                                {
                                    uploadType === 'document' &&
                                    <input
                                        type="file"
                                        name="file"
                                        onChange={handleNewItemChange}
                                        className="form-control"
                                    />
                                }
                            </div>
                            <div className="col-md-6 form-group mb-4">
                                <label>Nombre</label>
                                <input
                                    placeholder="nombre"
                                    autoFocus
                                    value={newItemData?.name}
                                    onChange={handleNewItemChange}
                                    name="name"
                                    type="text"
                                    className="form-control"
                                />
                            </div>
                            <div className="col-md-6 form-group mb-4">
                                <label>Precio Referencia</label>
                                <input
                                    placeholder="precio"
                                    value={newItemData?.price}
                                    onChange={handleNewItemChange}
                                    name="price"
                                    type="number"
                                    className="form-control"
                                />
                            </div>
                            <div className="col-md-6 form-group mb-4">
                                <label>Proveedor</label>
                                <input
                                    placeholder="proveedor"
                                    value={newItemData?.providerName}
                                    type="text"
                                    className="form-control"
                                    name="providerName"
                                    onChange={handleNewItemChange}
                                />
                            </div>
                            <div className="col-md-6 form-group mb-4">
                                <label>Descripción</label>
                                <input
                                    placeholder="descripción"
                                    value={newItemData?.description}
                                    type="text"
                                    className="form-control"
                                    name="description"
                                    onChange={handleNewItemChange}
                                />
                            </div>
                            <div className="col-md-12 mb-3">
                                <div className="row align-items-center mb-1">
                                    <div className="col-md-6">
                                        <label className="fw-bold">
                                            Categoría
                                        </label>
                                    </div>
                                    <div className="col-md-6">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Buscar..."
                                            value={categoriesFilters?.path}
                                            onChange={(e) => {
                                                setCurrentCategories([]);
                                                setCategoriesFilters(old => ({ ...old, path: e.target.value }));
                                            }}
                                        />
                                    </div>
                                </div>

                                <ul class="list-group" style={{ maxHeight: 300, overflow: 'auto' }}>
                                    {
                                        currentCategories?.map((category, i) => {
                                            const level = category?.path?.split("->").length - 1;
                                            return (
                                                <li class="list-group-item py-1">
                                                    <input
                                                        class={`form-check-input me-1 ms-${level > 0 ? level + 1 : 0}`}
                                                        type="checkbox"
                                                        checked={newItemData?.category_id == category?.id}
                                                        value={category?.id}
                                                        onChange={() => setNewItemData(old => ({ ...old, category_id: category?.id }))}
                                                        id={`category-check-${category?.id}`}
                                                    />
                                                    <label
                                                        class={`form-check-label ${level === 0 ? 'fw-bold text-primary' : 'fw-bold'}`}
                                                        for={`category-check-${category?.id}`}
                                                    >
                                                        {category?.path}
                                                    </label>
                                                </li>
                                            )
                                        })
                                    }
                                    {
                                        !loadingCategories && currentCategories?.length < 1 ?
                                            <li class="list-group-item text-center">
                                                No se encontrarón resultados.
                                            </li>
                                            :
                                            null
                                    }
                                    {
                                        loadingCategories ?
                                            <li class="list-group-item text-center">
                                                <div class="spinner-border text-primary" role="status">
                                                    <span class="visually-hidden">Loading...</span>
                                                </div>
                                            </li>
                                            :
                                            null
                                    }
                                    {
                                        !loadingCategories && numberOfPages > categoriesFilters?.page ?
                                            <li class="list-group-item text-center">
                                                <button
                                                    onClick={() => setCategoriesFilters((old) => ({ ...old, page: old?.page + 1 }))}
                                                    type="button"
                                                    className="btn btn-primary"
                                                >
                                                    Cargar más
                                                </button>
                                            </li>
                                            :
                                            null
                                    }
                                </ul>
                            </div>
                            <div className="col-md-12 text-center">
                                <p className="text-danger text-center">
                                    ⚠️ Los equipos y repuestos informáticos deben ser canalizados con Soporte TI ⚠️
                                </p>
                                <button onClick={handleAddNewItem} className="btn btn-success">
                                    Agregar
                                </button>
                            </div>
                        </div>
                    </form >
                </Modal.Body>
                <Modal.Footer>
                    <button onClick={() => setShowModal?.(false)} className="btn btn-danger">
                        Cerrar
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ManualItemForm;